import { Component, NgZone, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';

@Component({
  selector: 'app-reset-password',
  templateUrl: './reset-password.component.html',
  styleUrls: ['./reset-password.component.scss']
})
export class ResetPasswordComponent implements OnInit {

  m_hash: string;
  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private ngZone: NgZone) { }

  ngOnInit() {
    if (this.route.snapshot.queryParamMap.has('q'))
      this.m_hash = this.route.snapshot.queryParamMap.get('q');
  }

  redirectToLogin() {
    this.ngZone.run(() => this.router.navigate(['./anmelden'])).then();
  }

}
